module.exports = __webpack_public_path__ + "static/media/product.224bc12c.png";